/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import {
  SegmentedControlItem,
  SegmentedControl as VSegmentedControl
} from '@veneer/core';
import React from 'react';
import './styles.scss';
import { withAnalytics } from '@veneer/analytics';
import { SegmentedControlProps } from './types';
import { generateID } from '../../base/helper';

/**
 * UI Toolkit Segmented Control component based on Veneer Segmented Control
 * @public
 */
const TSegmentedControl: React.FC<SegmentedControlProps> = ({
  id = generateID('clientos-ui-toolkit-segmented-control'),
  defaultItem = -1,
  items,
  disabled,
  onChange
}) => {
  return (
    <div
      className={`clientos-ui-toolkit-segmented-control ${disabled ? 'clientos-ui-toolkit-segmented-control--disabled' : ''}`}
      id={id}
    >
      <VSegmentedControl
        defaultItem={defaultItem}
        onChange={onChange}
        id={`${id}__segmented-control`}
      >
        {items?.map((item, index) => (
          <SegmentedControlItem
            key={index}
            index={index}
            id={`${id}__segmented-control__item-${index}`}
            icon={
              <div
                className={`clientos-ui-toolkit-segmented-control__item ${disabled ? 'clientos-ui-toolkit-segmented-control__item--disabled' : ''}`}
                id={`${id}__segmented-control__item-${index}__icon`}
              >
                {item.icon}
                <p
                  className="clientos-ui-toolkit-segmented-control__label label"
                  id={`${id}__segmented-control__item-${index}__label`}
                >
                  {item.label}
                </p>
              </div>
            }
          />
        ))}
      </VSegmentedControl>
    </div>
  );
};

export const SegmentedControlAnalytics = withAnalytics(TSegmentedControl);
export default TSegmentedControl;
